import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "@mes-slalom/ui-common-lib";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import * as uuid from "uuid";
import { environment } from "../../environments/environment";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  if (req.url.includes(environment.auth_endpoint)) {
    return next(req);
  }

  return from(auth.getValidAccessToken()).pipe(
    switchMap((token) => {
      if (token) {
        req = req.clone({
          setHeaders: {
            "Authorization": `Bearer ${token}`,
            "Accept": "application/json",
            "Correlation-Object": JSON.stringify({ correlationId: uuid.v4() }), // TODO, non random uuid?
          },
        });
      }
      return next(req);
    })
  );
};
